import * as React from 'react';
import { AnsweredQuestionDto } from '../../../../pages/answeredQuestionnaireTypes';
import { Table } from '@material-ui/core';
import { TableHead } from '@material-ui/core';
import { TableRow } from '@material-ui/core';
import { TableCell } from '@material-ui/core';
import { TableBody } from '@material-ui/core';
import { translation } from '../../../../i18n';
import MultilineText from '../../../MultilineText';

interface Props {
  answeredQuestion: AnsweredQuestionDto,
  enableComment: boolean
}

class AnsweredMultipleColumnQuestion extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{width: '20%'}}>{translation.t('answeredComponent.columnTitles.employee')}</TableCell>
            {
              this.props.answeredQuestion.columns!!.map(column => {
                  return (<TableCell key={column.id}>{column.title}</TableCell>)
                }
              )
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            this.props.answeredQuestion.personalizedAnswers.map((answer, rowIndex) => (
              <TableRow key={this.props.answeredQuestion.id.toString() + answer.employee.id.toString()}>
                <TableCell>{answer.employee.firstName + ' ' + answer.employee.lastName}</TableCell>
                {this.props.answeredQuestion.columns!!.map((value, columnIndex) => {
                    const answers = answer.columnAnswers;
                    if (answers === undefined) {
                      return (<TableCell key={`${rowIndex}.${columnIndex}`}>-</TableCell>)
                    }
                    const currentColumnAnswer = answers.find(columnAnswer => columnAnswer.column.id === value.id);
                    if (currentColumnAnswer === undefined) {
                      return (<TableCell key={`${rowIndex}.${columnIndex}`}>-</TableCell>)
                    } else {
                      return (<TableCell key={`${rowIndex}.${columnIndex}`}><MultilineText text={currentColumnAnswer.answer}/></TableCell>)
                    }
                  }
                )}
              </TableRow>
            ))
          }
          {
            this.renderCommentIfNeeded()
          }
        </TableBody>
      </Table>
    )
  }

  private renderCommentIfNeeded() {
    const comment = this.props.answeredQuestion.comment;
    const columns = this.props.answeredQuestion.columns;
    if (!this.props.enableComment && comment != null && (columns !== null || columns !== undefined)) {
      return (
        <TableRow key={'comment'}>
          <TableCell>{translation.t('comment.comment')}</TableCell>
          <TableCell colSpan={columns!!.length}><MultilineText text={comment.comment}/></TableCell>
        </TableRow>
      )
    } else {
      return <></>
    }
  }

}

export default AnsweredMultipleColumnQuestion;
